export const canVisitPageInKioskMode = (url: string): boolean => {
	return url === "/pin"
}
